@if (show$$()) {
<div class="buttons-box-tab right">
    <div class="buttons vertical" @show>
        @if (tabVisible$$() && tabPositionOffStandard$$() && !locked$$()) {
            <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_positionReset()"
                [tooltip]="'reset tab position'"
                [tooltipPosition]="'left'"
            >
                <app-icon name="tab-reset" />
            </app-button-mini-fab>
        }
        @if (tabVisible$$() && sectionDetails_show$$() && btnEditShow$$()) {
            <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_editShow()"
                [disabled]="btnEditDisabled$$()"
                [tooltip]="btnEditTooltip$$()"
                [tooltipPosition]="'left'"
            >
                <app-icon name="edit" />
            </app-button-mini-fab>
        }
        @if (tabVisible$$() && !locked$$()) {
            <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_tabHide()"
                [tooltip]="'hide tab section'"
                [tooltipPosition]="'left'"
            >
                <app-icon name="tab-min" />
            </app-button-mini-fab>
        }
        @if (!tabVisible$$() && sectionDetails_show$$()) {
            <app-button-mini-fab class="vertical-buttons"
                (btnClick)="emit_tabShow()"
                [tooltip]="'show tab section'"
                [tooltipPosition]="'left'"
            >
                <app-icon name="tab-up" />
            </app-button-mini-fab>
        }
    </div>
</div>
}
